import React, {Component} from 'react';
import {observer} from 'mobx-react';
import './styles.scss';
import CircularLoader from "../../components/CircularLoader";

@observer
class VideoAskToJoin extends Component {

    render() {
        return (
            <div className="remote remote-waiting"><CircularLoader/></div>
        );

    }
}

export default VideoAskToJoin;
